exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sp-cart-item-thumbnail {\n    width: 60px;\n}\n.sp-cart-item-quantity {\n    z-index: 1;\n}\n.sp-cart-item-td {\n    padding: 0;\n}\n.sp-cart-item-container {\n    padding: 10px 12px 0 0;\n}\n", ""]);

// exports
